import { useState, useEffect } from "react";

/**
 * useDebounce
 * Atrasa a atualização de um valor até que o usuário pare de digitar.
 * Ideal para campos de busca — evita chamadas excessivas ao Firestore.
 * 
 * @param {any} value - Valor a ser "debounced"
 * @param {number} delay - Tempo em ms (padrão: 400ms)
 * 
 * Exemplo:
 *   const [search, setSearch] = useState("");
 *   const debouncedSearch = useDebounce(search, 400);
 *   useEffect(() => { /* buscar com debouncedSearch * / }, [debouncedSearch]);
 */
export const useDebounce = (value, delay = 400) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
};
